module.exports = __webpack_public_path__ + "df2c2b4490005288e49baffa071e2bee.svg";